// 判断移动端
export function judgeDevicePcOrMobile() {
    const userAgent = navigator.userAgent
    return /android|ipad|iphone|ipod|mobile/i.test(userAgent)
}

// 判断设备类型 IOS / Android
export function getMobileOperatingSystem() {
    const userAgent = navigator.userAgent

    // ios
    if (/iPad|iPhone|iPod/.test(userAgent) && !('MSStream' in window)) {
        return 'ios'
    }

    // Android
    if (/android/i.test(userAgent)) {
        return 'android'
    }

    // Other OS
    return 'unknown'
}

// 判断是否是微信内嵌浏览器
export function isWeChatBrowser() {
    const userAgent = window.navigator.userAgent.toLowerCase()
    return userAgent.includes('micromessenger')
}